
 export default {
    props: ['diplome', 'link'],
 
 }
 